import { BasicStyle } from "../types";

const CopiedStyleContext = React.createContext<ReturnType<typeof React.useState<BasicStyle>>>(null);

export function useCopiedStyle(): ReturnType<typeof React.useState<BasicStyle>> {
    const value = React.useContext(CopiedStyleContext);
    if (!value) {
        throw new Error("`useCopiedStyle()` can only be used within a `<CopiedStyleContextProvider>`");
    }
    return value;
}

export const CopiedStyleContextProvider = CopiedStyleContext.Provider;
